import * as React from "react";
import Svg, { Path } from "react-native-svg";

export const AddToCalendarIcon = (props: any) => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <Path
        d="M16 2V6"
        stroke="#251F2C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M8 2V6"
        stroke="#251F2C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M3 10H21"
        stroke="#251F2C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M17 14.5V21.5"
        stroke="#251F2C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M13.5 18H20.5"
        stroke="#251F2C"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <Path
        d="M21 14V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V20C3 21.1046 3.89543 22 5 22H13"
        stroke="#251F2C"
        stroke-width="2"
        stroke-linecap="round"
      />
    </Svg>
  );
};
